"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dropdown = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const IcChevronDownSm_1 = __importDefault(require("../Icons/IcChevronDownSm"));
const IcChevronUpSm_1 = __importDefault(require("../Icons/IcChevronUpSm"));
const Box_1 = require("../Box");
const Typography_1 = require("../Typography");
const ForwardRefHOC_1 = __importDefault(require("../ForwardRefHOC"));
var KEYS_CODES;
(function (KEYS_CODES) {
    KEYS_CODES["UP"] = "ArrowUp";
    KEYS_CODES["DOWN"] = "ArrowDown";
    KEYS_CODES["ENTER"] = "Enter";
    KEYS_CODES["TAB"] = "Tab";
    KEYS_CODES["ESC"] = "Escape";
})(KEYS_CODES || (KEYS_CODES = {}));
const Dropdown = (props) => {
    const { className, forwardedRef, options, id, onChange, zIndex = null } = props, restProps = __rest(props, ["className", "forwardedRef", "options", "id", "onChange", "zIndex"]);
    const [showOptions, setShowOptions] = react_1.useState(false);
    const [selectedOption, setSelectedOption] = react_1.useState(options[0]);
    const [selectedOptionIndex, setSelectedOptionIndex] = react_1.useState(0);
    const dropdownButtonRef = react_1.useRef(null);
    const dropdownOptionsRef = react_1.useRef(null);
    react_1.useEffect(() => {
        const onClickOutsideHandler = (event) => {
            const dropdownButton = dropdownButtonRef.current;
            const dropdownOptions = dropdownOptionsRef.current;
            const target = event.target;
            if (!(dropdownButton === null || dropdownButton === void 0 ? void 0 : dropdownButton.contains(target)) &&
                !(dropdownOptions === null || dropdownOptions === void 0 ? void 0 : dropdownOptions.contains(target))) {
                setShowOptions(false);
            }
        };
        const options = { capture: true };
        document.addEventListener('click', onClickOutsideHandler, options);
        return () => {
            document.removeEventListener('click', onClickOutsideHandler, options);
        };
    }, []);
    react_1.useEffect(() => {
        let defaultOptionIndex = 0;
        const defaultOption = options.find((option, index) => {
            defaultOptionIndex = index;
            return typeof option === 'object' && option.selected;
        });
        setSelectedOptionIndex(defaultOption ? defaultOptionIndex : 0);
        setSelectedOption(defaultOption || options[0]);
    }, [options]);
    const getLabel = (option) => {
        if (typeof option === 'string')
            return option;
        else
            return option['label'];
    };
    const selectOption = (option, index) => {
        setSelectedOption(option);
        setShowOptions(false);
        setSelectedOptionIndex(index);
        onChange && onChange(option);
    };
    const isSelectedOption = (option) => getLabel(option) === getLabel(selectedOption);
    const finalClassName = classnames_1.default('cl-dropdown-root', 'us', className);
    const focusOption = (optionIndex) => {
        const element = document.querySelector(`[data-original-index='${id}-${optionIndex}']`);
        if (element) {
            element.focus();
            setSelectedOptionIndex(optionIndex);
        }
    };
    const onKeyDownItemHandler = (event) => {
        let nextSelectedOptionIndex = selectedOptionIndex;
        if (event.key !== KEYS_CODES.TAB) {
            event.preventDefault();
        }
        switch (event.key) {
            case KEYS_CODES.DOWN: {
                nextSelectedOptionIndex = Math.min(options.length - 1, selectedOptionIndex + 1);
                focusOption(nextSelectedOptionIndex);
                break;
            }
            case KEYS_CODES.UP: {
                nextSelectedOptionIndex = Math.max(0, selectedOptionIndex - 1);
                focusOption(nextSelectedOptionIndex);
                break;
            }
            case KEYS_CODES.ENTER: {
                selectOption(options[selectedOptionIndex], selectedOptionIndex);
                setShowOptions(false);
                break;
            }
            case KEYS_CODES.ESC: {
                setShowOptions(false);
                break;
            }
        }
    };
    const onKeyDownHandler = (event) => {
        if (!showOptions && event.key === KEYS_CODES.DOWN) {
            setShowOptions(true);
        }
        onKeyDownItemHandler(event);
    };
    return (react_1.default.createElement("div", Object.assign({ className: finalClassName, ref: forwardedRef }, restProps, { role: 'button', onKeyDown: onKeyDownHandler, tabIndex: 0 }),
        react_1.default.createElement(Box_1.Box, { id: `${id}-drop-down`, "aria-label": `${id}-drop-down`, className: classnames_1.default('cl-dropdown-control', 'cp'), borderColor: showOptions ? 'neutral-primary' : 'neutral-border', onClick: () => setShowOptions(!showOptions), forwardedRef: dropdownButtonRef },
            react_1.default.createElement(Typography_1.Typography, { width: 90 }, getLabel(selectedOption)),
            showOptions ? (react_1.default.createElement(IcChevronUpSm_1.default, { fill: 'interaction-primary' })) : (react_1.default.createElement(IcChevronDownSm_1.default, { fill: 'interaction-primary' }))),
        showOptions && (react_1.default.createElement(Box_1.Box, { className: classnames_1.default('cl-dropdown-menu', 'cp'), width: 100, role: 'listbox', "aria-labelledby": `${id}-drop-down`, "aria-describedby": `${id}-drop-down`, "aria-errormessage": props['aria-errormessage'], style: { zIndex }, forwardedRef: dropdownOptionsRef }, options &&
            options.map((option, i) => (react_1.default.createElement(Typography_1.Typography, { tabIndex: i, role: 'option', "aria-selected": isSelectedOption(option), key: i, color: isSelectedOption(option)
                    ? 'interaction-primary'
                    : 'neutral-secondary', onClick: () => selectOption(option, i), "data-original-index": `${id}-${i}`, className: classnames_1.default('cl-dropdown-menu-item', {
                    ['cl-dropdown-menu-item-active']: selectedOptionIndex === i &&
                        !isSelectedOption(option)
                }) }, getLabel(option))))))));
};
exports.Dropdown = Dropdown;
exports.Dropdown.displayName = 'Dropdown';
exports.default = ForwardRefHOC_1.default(exports.Dropdown);
